import { readBrandEnv } from '../brand.js';
import { DEFAULT_API_URL } from '../default-urls.js';

export { DEFAULT_API_URL };

export function resolveApiUrl(): string {
  return readBrandEnv('CANARY_API_URL') ?? DEFAULT_API_URL;
}
